import {PollModel} from './PollModel.js';

export class PollFolderModel {
	constructor() {
		this.listeners = [];
		this.polls = [];
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(m => m!=l);
	}
	addPoll(p) {
		this.polls.push(p);
		this.listeners.map(l => l.folder_poll_added(p) );
	}
	removePoll(p) {
		this.listeners.map(l => l.folder_poll_removed(p) );
	}
	updatePoll(p) {
		this.listeners.map(l => l.fonder_poll_updated(p) );
	}
	fetchFolder(url) {
		fetch(url)
		.then( res=>res.json() )
		.then( js=>{
			console.log(`got js = `, js);
			js.map( p=>{
				let m = new PollModel();
				m.fromObject(p);
				this.addPoll(m);
			});
			return Promise.resolve(true);
		}).catch(err=>this.doError(err));
	}

	doError(err) {
		console.log(err);
		alert(err);
	}		
}